import { render, staticRenderFns } from "./managerecord.vue?vue&type=template&id=603a0980&scoped=true&"
import script from "./managerecord.vue?vue&type=script&lang=js&"
export * from "./managerecord.vue?vue&type=script&lang=js&"
import style0 from "./managerecord.vue?vue&type=style&index=0&id=603a0980&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603a0980",
  null
  
)

export default component.exports